import { gql } from '@apollo/client';

export const AppRequestFragment = gql`
  fragment AppRequestFragment on AppRequest {
    id
    appName
    contactEmail
    contactName
    description
    declineReason
    status
    policy {
      accept
      decline
    }
    requesterCompanyName
    requesterCompanyWebsite
    vendorName
  }
`;
